import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { HashDisplay } from "./index.js"; // FIXME: circular deps
import { AdminTwinClient, TwinClient } from "../lib/client";
import { Spinner } from "./Spinner.js";

export function useTwinLookup(hash) {
  let { data: twinUrl, isFetching } = useQuery({
    queryKey: ["lookup", hash],
    queryFn: async function lookupFn() {
      let adminClient = new AdminTwinClient({url:"https://admin.tracker-demo.biz.todaq.net"});
      return await adminClient.lookup(hash);
    },
    enabled: !!hash,
    staleTime: Infinity
  });
  return { twinUrl, isFetching };
}

export function usePersona(twinUrl) {
  let { data: persona, isFetching } = useQuery({
    queryKey: ["GET", twinUrl, "/persona"],
    queryFn: async function getPersonaFn() {
      if (!twinUrl) return null;
      let res = await TwinClient.persona(twinUrl);
      let info = res?.instances[0]?.info;
      try {
        return JSON.parse(info);
      } catch (_) {
        return info;
      }
    },
    enabled: !!twinUrl,
    retry: false,
    staleTime: Infinity
  });
  return { persona, isFetching };
}

export function usePersonaOrAddress(hash) {
  let { twinUrl, isFetching: isFetchingLookup } = useTwinLookup(hash);
  let { data: address, isFetching: isFetchingAddress } = useQuery({
    queryKey: ["address", twinUrl],
    queryFn: async function getAddressFn() {
      return await (new TwinClient({url: twinUrl})).address();
    },
    enabled: !!twinUrl,
    retry: false,
    staleTime: Infinity
  });
  let { persona, isFetching: isFetchingPersona } = usePersona(twinUrl);
  return { persona, address, isFetching: isFetchingLookup || isFetchingAddress || isFetchingPersona };
}


export function AddressCard({ h, state }) {
  if (!state) {
    state = useState(false);
  }
  let { persona, address, isFetching } = usePersonaOrAddress(h);
  function AddressDisplay({ h }) {
    return <div className="rounded flex justify-end ~max-w-fit">
      {persona ?
        <div className="text-nowrap">
          {typeof persona === "string" ?
            <div>{persona}</div>
            :
            <>
              <div >{persona?.name}</div>
              <div className="text-xs float-left">{persona?.email}</div>
            </>
          }
        </div>
        :
        <div className="flex flex-row group/address gap-1" >
          <HashDisplay h={address || h} fontSize={"14px"} />
          <Spinner className="!size-5" hidden={!isFetching || h == "00"}/>
        </div>
      }
    </div>
  }

  return <AddressDisplay h={h} />;
}
